import React, { useContext, useEffect, useState } from "react";
import { Button, Space, Badge, message } from "antd";
import { AppContext } from "src/context";
import { SyncOutlined } from "@ant-design/icons";
import ThemeToggler from "../common/base/ThemeToggleButton";
import ProfileDropdownMenu from "./ProfileDropdownMenu";
import StartTimerComponent from "../modules/project/project-list/components/tabs/timesheet/Timer";
import BackgroundNotification from "src/common/utils/notification";
import { Notification } from "src/common/types";
import NotificationDropdown from "./notification/NotificationDropdown";

import NewVersionModal from "src/navbar-horizontal/NewVersionModal";
import coreFunctions from "src/common/utils/coreFunctions";
import { getCookie, setCookie } from "src/common/utils/cookies";

interface NavbarActionsProps {
  theme: "light" | "dark";
  toggleTheme: () => void;
}

const NavbarActions: React.FC<NavbarActionsProps> = ({
  theme,
  toggleTheme,
}) => {
  const [checking, setChecking] = useState(false);
  const { state } = useContext(AppContext);
  const [items, setItems] = useState<Notification[]>([]);
  const [showNewVersionModal, setShowNewVersionModal] = useState(false);
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const [spinOnce, setSpinOnce] = useState(false);

  const getNotifications = async () => {
    if (localStorage.getItem("token")) {
      setChecking(true);

      const NOTIFICATION = new BackgroundNotification();

      setTimeout(async () => {
        const data = await NOTIFICATION.getNotifications();
        setItems(data as Notification[]);
      }, 1000);

      setTimeout(() => {
        setChecking(false);
      }, 1000);
    }
  };

  useEffect(() => {
    getNotifications();
  }, [state.check_notification]);

  const checkUpdates = () => {
    coreFunctions.hasNewVersion((data: any) => {
      const version = parseFloat(getCookie("version") || "") || 0;

      if (version < data.version) {
        setHasNewVersion(true);

        localStorage.setItem("new_version", data.version);
        localStorage.setItem(
          "new_version_description",
          data.version_description
        );

        setCookie("new_version", data.version);
      } else {
        setHasNewVersion(false);
      }
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      checkUpdates();
    }, 55000);

    checkUpdates();
    return () => clearInterval(interval);
  }, []);

  return (
    <Space size="middle">
      <StartTimerComponent />

      {/* Theme Toggle Button */}
      <ThemeToggler disabled={true} />

      {hasNewVersion && (
        <>
          <Button
            color="red"
            onClick={() => {
              setShowNewVersionModal(true);
            }}
          >
            <Badge dot offset={[0, 0]} title="New version available">
              <SyncOutlined style={{ fontSize: 15 }} />
            </Badge>
          </Button>
          <NewVersionModal
            setShowModal={setShowNewVersionModal}
            showModal={showNewVersionModal}
          />
        </>
      )}

      <NotificationDropdown />

      {/* Nine Dot Menu */}
      {/* <Button shape="circle" icon={<AppstoreOutlined />} /> */}

      {/* User Avatar */}
      {<ProfileDropdownMenu />}
    </Space>
  );
};

export default NavbarActions;
